/**
 * 公开资料库页面完整 URL（hash 路由，无需登录）
 * @returns {string}
 */
export function buildLibraryPageUrl() {
  const base = window.location.origin + window.location.pathname
  return `${base}#/library`
}
